import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '../../Grid';
import { Button } from '../../../BuildingBlocks/Button';
import Modal from '../Modal';
import { StyledInternalGrid } from './ConfirmationModal.styles';
import Text from '../../../BuildingBlocks/Text/HeadingThird/HeadingThird';
import { StyledIcon } from '../../../BuildingBlocks/OverlayButton/OverlayButton.styles';

function ConfirationModal(props) {
  const { open: propsOpen, title, icon, handleConfirmation, targetValue } = props;

  const [open, setOpen] = useState(propsOpen);
  const [loading, setLoading] = useState(false);

  const handleOpen = (event) => {
    if (event) event.stopPropagation();
    setOpen(true);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setOpen(false);
  };

  const handleAction = (event) => {
    if (event) event.stopPropagation();
    setLoading(true);
    handleConfirmation(targetValue);
  };

  return (
    <>
      <StyledIcon onClick={handleOpen} selectedIcon={icon} />
      <Modal handleClose={handleClose} showClose={false} open={open} width="600px" height="300px">
        <StyledInternalGrid>
          <Grid.Row>
            <Text align="center">{title}</Text>
          </Grid.Row>
          <Grid.Row style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Grid.Col xs={4}>
              <Button loading={loading} onClick={handleAction} size="sm" theme="blue" uppercase>
                confirm
              </Button>
            </Grid.Col>
            <Grid.Col xs={4}>
              <Button onClick={handleClose} size="sm" theme="ghost" uppercase>
                Cancel
              </Button>
            </Grid.Col>
          </Grid.Row>
        </StyledInternalGrid>
      </Modal>
    </>
  );
}

ConfirationModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  handleConfirmation: PropTypes.func,
  icon: PropTypes.shape({}),
  targetValue: PropTypes.string
};

ConfirationModal.defaultProps = {
  open: false,
  handleConfirmation: () => {},
  icon: {},
  title: '',
  targetValue: ''
};

export default ConfirationModal;
